import {
    CONTENTFUL_LOAD_CLIENT_PARTIAL,
    CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS,
    CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED,
    FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: {}
};

const fetchingContentFulPartial = (state, action) => {
    return {
        isFetching: true,
        entities: {
            ...state.entities
        }
    };
};

const fetchContentFulPartialSuccess = (state, action) => {
    return {
        isFetching: false,
        entities: {
            ...state.entities,
            [action.action.contentID]: { error: false, atpFeedPartialContent: action.atpFeedPartialContent }
        }
    };
};

const fetchContentFulPartialFail = (state, action) => {
    return {
        isFetching: false,
        entities: {
            ...state.entities,
            [action.action.contentID]: { error: true, atpFeedPartialContent: null }
        }
    };
};

export const isPartialArticleFetching = (state) => {
    return state.atpFeedPartialContent.isFetching;
};

export const getPartialArticle = (state, contentID) => {
    return state.atpFeedPartialContent.entities[contentID];
};

const handlers = {
    [CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS]: fetchContentFulPartialSuccess,
    [CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED]: fetchContentFulPartialFail,
    [FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL]: fetchingContentFulPartial
};

export default function atpFeedPartialContent(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchContentFulPartial(contentID, locale) {
    return {
        type: CONTENTFUL_LOAD_CLIENT_PARTIAL,
        payload: {
            contentID,
            locale
        }
    };
}
